"use client";

import { Search, SlidersHorizontal } from "lucide-react";

export default function ProductSearchBar({
  value = "",
  onChange,
  placeholder = "محصول خود را اینجا جستجو کنید",
  selectedCount = 0,
  onToggleFilters,
  onSearch,
  className = "",
  showFilters = true,
}) {
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onSearch?.();
    }
  };

  return (
    <div className={`w-full max-w-5xl mx-auto ${className}`}>
      <div className="flex items-center gap-3">
        {/* Search input */}
        <div className="relative flex-1">
          <input
            type="text"
            placeholder={placeholder}
            value={value}
            onChange={(e) => onChange?.(e.target.value)}
            onKeyDown={handleKeyDown}
            className="w-full h-14 px-6 pr-14 rounded-2xl bg-[#1D1E2066] border border-white/20
                     focus:outline-none text-white placeholder:text-mute
                     transition-colors text-right font-dana-light text-base"
          />
          <Search className="absolute right-5 top-1/2 -translate-y-1/2 text-mute" size={24} />
        </div>

        {/* filter button */}
        {onToggleFilters && showFilters && (
          <button
            type="button"
            onClick={onToggleFilters}
            className="cursor-pointer h-14 w-14 shrink-0 rounded-2xl border border-white/20 bg-[#1D1E2066] flex items-center justify-center hover:border-white/40 transition-colors relative"
            aria-label="فیلتر محصولات">
            <SlidersHorizontal size={24} className="text-white" />
            {selectedCount > 0 && (
              <span className="absolute -top-2 -left-2 bg-berry-500 text-white text-[10px] w-5 h-5 flex items-center justify-center rounded-full">
                {selectedCount}
              </span>
            )}
          </button>
        )}
      </div>
    </div>
  );
}


